// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__198yF","amount":"Amount_amount__Q95EX","tip":"Amount_tip__3n_td","tipHeader":"Amount_tipHeader__10aFw","tipsWrap":"Amount_tipsWrap__39NNb"};